import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import Deprecated from '../../core/Deprecated';
import { ProjectConsumer } from '../../core/providers/ProjectProvider';
import SearchSelect from '../../core/SearchSelect';
import { globalStyles as styles } from '../../core/style/gstheme';
import { checkValidForDatatype, getGraphFromProject, makeCancelable } from '../../core/utils/utils';
import GS from '../../grafsync/grafsync';
import SchemeLink from '../core/SchemeLink';
import XL from '../core/XL';

class FindOntologyRelatedConcept extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            offerExternal: false,
            searchKey: "",
            text: ""
        };
    }

    loadData(id) {
        this.cancellable = makeCancelable(GS.loadData([id], {}, this.props.graph, true));
        return this.cancellable;
    }

    computeSearch = (value, lang, projectIRI, skosXL) => {
        let fullSearch =
        {
            search: this.props.searchClasses.includes("http://www.w3.org/2004/02/skos/core#ConceptScheme")
                || this.props.searchClasses.includes("http://www.w3.org/2004/02/skos/core#Collection")
                || this.props.searchClasses.includes("http://www.w3.org/2004/02/skos/core#OrderedCollection") ?
                [
                    {
                        predicate: "http://purl.org/dc/terms/title",
                        ...(value !== "") && {
                            value: value,
                            isExactMatch: false
                        }
                    }
                ]
                :
                [
                    {
                        predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                        value: "http://www.w3.org/2004/02/skos/core#Concept"
                    },
                    {
                        predicate: "http://www.w3.org/2004/02/skos/core#prefLabel",
                        ...(value !== "") && {
                            value: value,
                            isExactMatch: false
                        }
                    }
                ],
            graph: [getGraphFromProject(projectIRI)],
            pageSize: 20,
            exclude: this.props.exclude,
            entailment: skosXL ? ["propertyChain"] : [],
            language: lang,
            predicates: [
                "http://www.w3.org/2004/02/skos/core#prefLabel",
                "http://purl.org/dc/terms/title",
                "http://www.w3.org/2002/07/owl#deprecated",
                "https://grafsync.graphifi.com/schema/gs/iri",
                "http://www.w3.org/2004/02/skos/core#inScheme"
            ]
        };
        if (this.props.searchClasses.length > 0) fullSearch.search.push({
            predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
            value: this.props.searchClasses
        });
        return fullSearch;
    };

    includeResource = (id) => {
        this.props.onIncludeResource(id);
        this.setState({
            text: "",
            ...(this.props.resetOnSelect) && { searchKey: this.state.text }
        });
    };

    addExternal = () => this.includeConcept(this.state.externalIRI);

    declineExternal = () => this.setState({ text: "", offerExternal: false });

    offerExternal = (iri, valid = true) => {
        if (!valid || iri.includes("graphifi")) {
            this.setState({
                offerExternal: false
            });
        }
        else if (this.props.exclude.includes(iri)) {
            this.setState({
                offerExternal: false
            });
        }
        else {
            const isValid = checkValidForDatatype(iri, "http://www.w3.org/2001/XMLSchema#anyURI");
            this.setState({
                offerExternal: isValid,
                externalIRI: iri
            });
        }
    };

    updateSearchText = (text) => this.setState({ text, offerExternal: false });

    render() {
        const { allowEmpty, allowIRI, singleValue, selectedStyle, height } = this.props;
        const { text, searchKey } = this.state;

        return (
            <ProjectConsumer>
                {({ id: projectIRI, defaultLang, skosXL }) => (
                    <div style={{ height }}>
                        <SearchSelect
                            key={searchKey}
                            dataTest="find-relationship"
                            focus={true}
                            allowIRIonNoResults={allowIRI}
                            sortByLength={true}
                            singleValue={singleValue}
                            selectedStyle={selectedStyle}
                            updateSearchText={this.updateSearchText}
                            allowEmpty={allowEmpty}
                            maxLength={250}
                            initialText={text}
                            search={(value, lang) => this.computeSearch(value, lang, projectIRI, skosXL)}
                            listSecondIcon={(result) => {
                                if (result.deprecated) return <Deprecated />;
                                if (result.isEntailed) return <XL />;
                                return null;
                            }}
                            listSelectionDisplay={(result, lang) => result.prefLabel ?
                                result.prefLabel[lang] ?
                                    Array.isArray(result.prefLabel[lang]) ?
                                        result.prefLabel[lang][0]
                                        :
                                        result.prefLabel[lang]
                                    :
                                    result.id
                                :
                                result.title ?
                                    result.title[lang] ?
                                        Array.isArray(result.title[lang]) ?
                                            result.title[lang][0]
                                            :
                                            result.title[lang]
                                        :
                                        result.id
                                    :
                                    result.id

                            }
                            listDisplay={(result, lang) => {
                                const text = result.prefLabel ?
                                    result.prefLabel[lang] ?
                                        Array.isArray(result.prefLabel[lang]) ?
                                            result.prefLabel[lang].sort().join(" AND ")
                                            :
                                            result.prefLabel[lang]
                                        :
                                        result.id
                                    :
                                    result.title ?
                                        result.title[lang] ?
                                            Array.isArray(result.title[lang]) ?
                                                result.title[lang][0]
                                                :
                                                result.title[lang]
                                            :
                                            result.id
                                        :
                                        result.id;
                                const currentIRI = result.iri ?
                                    result.iri[result.iri.length - 1]
                                    :
                                    result.id;
                                return <div>
                                    <Typography variant="body2">
                                        <span style={{ wordBreak: 'break-word' }}>
                                            <Tooltip
                                                PopperProps={{
                                                    "data-test": "result-tip"
                                                }}
                                                title={currentIRI}>
                                                <span data-test="result-text-words">{text}</span>
                                            </Tooltip>
                                        </span>
                                    </Typography>
                                    {result.inScheme && result.inScheme.map(scheme =>
                                        <SchemeLink handleNotAvailable={true} key={scheme} id={scheme} graph={result.inNamedGraph} defaultLang={defaultLang} />
                                    )}
                                </div>;
                            }}
                            sortProp={this.props.searchClasses.includes("http://www.w3.org/2004/02/skos/core#ConceptScheme")
                                || this.props.searchClasses.includes("http://www.w3.org/2004/02/skos/core#Collection")
                                || this.props.searchClasses.includes("http://www.w3.org/2004/02/skos/core#OrderedCollection") ?
                                "title"
                                :
                                "prefLabel"}
                            isClickableResult={(result) => !result.invalid && !result.deprecated}
                            title="Find a resource"
                            onClearResults={this.declineExternal}
                            onNoResults={allowIRI ? this.offerExternal : null}
                            lang={defaultLang}
                            chosen={this.includeResource} />
                    </div>
                )}
            </ProjectConsumer>
        );
    }
}

FindOntologyRelatedConcept.defaultProps = {
    searchClasses: [],
    projects: [],
    exclude: [],
    allowEmpty: false,
    singleValue: false,
    height: 200,
    resetOnSelect: true,
    allowIRI: true
};

FindOntologyRelatedConcept.propTypes = {
    searchClasses: PropTypes.array,
    exclude: PropTypes.array,
    height: PropTypes.number.isRequired,
    resetOnSelect: PropTypes.bool,
    allowIRI: PropTypes.bool,
    allowEmpty: PropTypes.bool,
    singleValue: PropTypes.bool,
    selectedStyle: PropTypes.object,
    onIncludeResource: PropTypes.func.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(FindOntologyRelatedConcept);